import { createSlice } from "@reduxjs/toolkit";
import { fetchSubjects, setContactUs } from "../thunks/helpThunk.tsx";
import { SubjectsDataType } from "../types/helpTypes.tsx";

interface State {
  isLoadingSubjects: boolean;
  isLoadingContactUs: boolean;
  subjects: SubjectsDataType | null;
}

const initialState: State = {
  isLoadingSubjects: false,
  isLoadingContactUs: false,
  subjects: null,
};
export const helpSlice = createSlice({
  name: "help",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSubjects.pending, (state) => {
      state.isLoadingSubjects = true;
    });
    builder.addCase(fetchSubjects.fulfilled, (state, action) => {
      state.isLoadingSubjects = false;
      if (action.payload) {
        state.subjects = action.payload;
      }
    });
    builder.addCase(setContactUs.pending, (state) => {
      state.isLoadingContactUs = true;
    });
    builder.addCase(setContactUs.fulfilled, (state) => {
      state.isLoadingContactUs = false;
    });
  },
});
